module.exports = __webpack_public_path__ + "static/media/ipad_acc_light.85eadf45.svg";